(function () {
  'use strict';

  function setProductImage(index) {
    var images = Array.from(document.querySelectorAll('.thumb-item'));
    var mainImg = document.getElementById('mainProductImg');
    if (!images.length || !mainImg || !images[index]) return;

    var image = images[index];
    var src = image.getAttribute('data-src');
    if (!src) return;

    if (mainImg.getAttribute('src') === src) return;
    mainImg.classList.remove('is-ready');
    mainImg.classList.add('is-changing');
    var preload = new Image();
    preload.onload = function () {
      mainImg.src = src;
      mainImg.classList.remove('is-changing');
      mainImg.classList.add('is-ready');
      window.setTimeout(function () { mainImg.classList.remove('is-ready'); }, 360);
    };
    preload.onerror = function () {
      mainImg.src = src;
      mainImg.classList.remove('is-changing');
    };
    preload.src = src;

    images.forEach(function (thumb, thumbIndex) {
      thumb.classList.toggle('active', thumbIndex === index);
    });

  }

  function setVariantImage(src) {
    if (!src) return;
    var images = Array.from(document.querySelectorAll('.thumb-item'));
    var index = images.findIndex(function (thumb) {
      return thumb.getAttribute('data-src') === src;
    });

    if (index >= 0) {
      setProductImage(index);
      return;
    }

    var mainImg = document.getElementById('mainProductImg');
    if (mainImg && mainImg.getAttribute('src') !== src) {
      mainImg.classList.remove('is-ready');
      mainImg.classList.add('is-changing');
      var preload = new Image();
      preload.onload = function () {
        mainImg.src = src;
        mainImg.classList.remove('is-changing');
        mainImg.classList.add('is-ready');
        window.setTimeout(function () { mainImg.classList.remove('is-ready'); }, 360);
      };
      preload.onerror = function () {
        mainImg.src = src;
        mainImg.classList.remove('is-changing');
      };
      preload.src = src;
    }
  }

  function renderProductPrice(element, value) {
    if (!element) return;
    var text = String(value || '').trim();
    var match = text.match(/^RD\$\s*(.*)$/);
    if (!match) {
      element.textContent = text;
      return;
    }
    element.replaceChildren();
    var currency = document.createElement('span');
    currency.className = 'price-currency';
    currency.textContent = 'RD$';
    var number = document.createElement('span');
    number.className = 'price-value';
    number.textContent = match[1];
    element.append(currency, number);
  }

  function updateVariantState(option) {
    if (!option) return;

    var price = document.getElementById('priceDisplay');
    var compare = document.getElementById('comparePrice');
    var save = document.getElementById('saveTag');
    var status = document.getElementById('variantStatus');
    var buyNow = document.querySelector('.btn-buy-now');
    var addCart = document.querySelector('.btn-add-cart');
    var variantSelect = document.getElementById('VariantSelect');

    var compareText = option.dataset.compare || '';
    if (price && option.dataset.price) renderProductPrice(price, option.dataset.price);
    if (compare) {
      renderProductPrice(compare, compareText);
      compare.hidden = !compareText;
    }
    if (save) {
      var current = parseFloat((option.dataset.price || '').replace(/[^0-9.,-]/g, '').replace(',', '.'));
      var original = parseFloat(compareText.replace(/[^0-9.,-]/g, '').replace(',', '.'));
      var discount = original > current ? Math.round((original - current) * 100 / original) : 0;
      save.textContent = discount ? '-' + discount + '%' : '';
      save.hidden = !discount;
    }

    var available = option.dataset.available === 'true';
    if (status) {
      status.textContent = available ? (variantSelect && variantSelect.dataset.availableLabel || 'Available') : (variantSelect && variantSelect.dataset.soldOutLabel || 'Sold out');
      status.classList.toggle('is-sold-out', !available);
    }
    [buyNow, addCart].forEach(function (button) {
      if (button) button.disabled = !available;
    });
    setVariantImage(option.dataset.image || '');
  }

  function initProductCardCarousels() {
    var mediaBlocks = Array.from(document.querySelectorAll('[data-product-card-media]'));
    mediaBlocks.forEach(function (media) {
      if (media.dataset.cardCarouselBound === 'true') return;
      var images = Array.from(media.querySelectorAll('[data-card-image]'));
      var card = media.closest('.prod-card');
      if (!card || images.length < 2) return;
      media.dataset.cardCarouselBound = 'true';

      var index = 0;
      var timer = null;
      function show(nextIndex) {
        index = (nextIndex + images.length) % images.length;
        images.forEach(function (image, imageIndex) {
          image.classList.toggle('is-active', imageIndex === index);
        });
      }
      function start(autoAdvance) {
        if (timer) return;
        if (autoAdvance) show(index + 1);
        timer = window.setInterval(function () { show(index + 1); }, 1450);
      }
      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
        show(0);
      }

      var previous = media.querySelector('[data-card-prev]');
      var next = media.querySelector('[data-card-next]');
      function manualMove(step, event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        show(index + step);
        if (timer) {
          window.clearInterval(timer);
          timer = window.setInterval(function () { show(index + 1); }, 1450);
        }
      }
      if (previous) previous.addEventListener('click', function (event) { manualMove(-1, event); });
      if (next) next.addEventListener('click', function (event) { manualMove(1, event); });

      card.addEventListener('mouseenter', function () { start(true); });
      card.addEventListener('mouseleave', stop);
      card.addEventListener('focusin', function () { start(true); });
      card.addEventListener('focusout', function (event) {
        if (!card.contains(event.relatedTarget)) stop();
      });
    });
  }

  function initRelatedCarousels() {
    Array.from(document.querySelectorAll('[data-related-track]')).forEach(function (track) {
      if (track.dataset.relatedCarouselBound === 'true') return;
      track.dataset.relatedCarouselBound = 'true';
      var previous = track.parentElement.querySelector('[data-related-prev]');
      var next = track.parentElement.querySelector('[data-related-next]');
      var step = function () { return Math.max(track.clientWidth * .82, 238); };
      if (previous) previous.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  function initCatalogPagination() {
    Array.from(document.querySelectorAll('[data-catalog-page-shell]')).forEach(function (catalog) {
      if (catalog.dataset.catalogPaginationBound === 'true') return;
      catalog.dataset.catalogPaginationBound = 'true';

      var items = Array.from(catalog.querySelectorAll('[data-catalog-item]'));
      var links = Array.from(catalog.querySelectorAll('[data-catalog-page-link]'));
      var pageSize = 12;
      var pageCount = Math.max(1, Math.ceil(items.length / pageSize));
      var initialPage = parseInt(new URL(window.location.href).searchParams.get('page') || '1', 10);
      var currentPage = Math.min(pageCount, Math.max(1, Number.isFinite(initialPage) ? initialPage : 1));

      function renderPage(page, shouldPushState, shouldScroll) {
        currentPage = Math.min(pageCount, Math.max(1, page));
        var firstItem = (currentPage - 1) * pageSize;
        items.forEach(function (item, index) {
          item.hidden = index < firstItem || index >= firstItem + pageSize;
        });
        links.forEach(function (pageLink) {
          var pageNumber = parseInt(pageLink.dataset.catalogPage || '', 10);
          var direction = pageLink.dataset.catalogDirection;
          if (direction === 'previous') pageLink.classList.toggle('is-disabled', currentPage === 1);
          if (direction === 'next') pageLink.classList.toggle('is-disabled', currentPage === pageCount);
          if (pageNumber) {
            var isCurrent = pageNumber === currentPage;
            pageLink.classList.toggle('is-current', isCurrent);
            if (isCurrent) pageLink.setAttribute('aria-current', 'page');
            else pageLink.removeAttribute('aria-current');
          }
        });

        if (shouldPushState) {
          var nextUrl = new URL(window.location.href);
          if (currentPage === 1) nextUrl.searchParams.delete('page');
          else nextUrl.searchParams.set('page', currentPage);
          nextUrl.hash = '';
          history.pushState({ catalogPage: currentPage }, '', nextUrl.href);
        }

        if (shouldScroll) {
          var header = document.querySelector('.header');
          var offset = header ? header.getBoundingClientRect().height + 18 : 18;
          var top = Math.max(0, catalog.getBoundingClientRect().top + window.scrollY - offset);
          var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: top, behavior: reducedMotion ? 'auto' : 'smooth' });
        }
      }

      renderPage(currentPage, false, false);
      catalog.__ozelotRenderPage = renderPage;

      catalog.addEventListener('click', function (event) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        var link = event.target.closest && event.target.closest('a[data-catalog-page-link]');
        if (!link || link.target === '_blank') return;
        event.preventDefault();
        var page = parseInt(link.dataset.catalogPage || '', 10);
        if (link.dataset.catalogDirection === 'previous') page = currentPage - 1;
        if (link.dataset.catalogDirection === 'next') page = currentPage + 1;
        if (!Number.isFinite(page) || page === currentPage) return;

        catalog.classList.add('is-catalog-swapping');
        window.requestAnimationFrame(function () {
          renderPage(page, true, true);
          window.setTimeout(function () { catalog.classList.remove('is-catalog-swapping'); }, 180);
        });
      });

      if (!window.__ozelotCatalogPopstateBound) {
        window.__ozelotCatalogPopstateBound = true;
        window.addEventListener('popstate', function () {
          var activeCatalog = document.querySelector('[data-catalog-page-shell]');
          if (!activeCatalog || typeof activeCatalog.__ozelotRenderPage !== 'function') return;
          var target = parseInt(new URL(window.location.href).searchParams.get('page') || '1', 10);
          activeCatalog.__ozelotRenderPage(target, false, true);
        });
      }
    });
  }

  function initPageTransitions() {
    if (window.Shopify && window.Shopify.designMode) return;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return;

    document.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link || link.target === '_blank' || link.hasAttribute('download') || link.closest('form') || link.hasAttribute('data-no-page-transition')) return;
      if (link.closest('[data-catalog-page-shell]')) return;

      var url;
      try { url = new URL(link.href, window.location.href); } catch (error) { return; }
      if (url.origin !== window.location.origin || url.protocol === 'mailto:' || url.protocol === 'tel:') return;
      if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return;
      if (url.href === window.location.href) return;

      event.preventDefault();
      document.documentElement.classList.add('is-page-exiting');
      window.setTimeout(function () { window.location.assign(url.href); }, 180);
    });
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function (character) {
      return {'&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'}[character];
    });
  }

  function formatDominicanPrice(value) {
    var price = String(value || '');
    if (price.indexOf('RD$') >= 0) return price;
    return price.replace(/US\$/g, 'RD$').replace(/USD/g, 'RD$').replace(/\$/g, 'RD$');
  }

  function initProductShare() {
    Array.from(document.querySelectorAll('[data-product-share]')).forEach(function (share) {
      var button = share.querySelector('[data-share-button]');
      var status = share.querySelector('[data-share-status]');
      var label = share.querySelector('[data-share-label]');
      if (!button) return;

      var defaultLabel = label ? label.textContent : button.textContent;
      var copiedLabel = button.getAttribute('data-copied-label') || 'Enlace copiado';
      var errorLabel = button.getAttribute('data-error-label') || 'No se pudo compartir';
      var resetTimer = null;

      function show(message) {
        if (label) label.textContent = message;
        if (status) status.textContent = message;
        window.clearTimeout(resetTimer);
        resetTimer = window.setTimeout(function () {
          if (label) label.textContent = defaultLabel;
          if (status) status.textContent = '';
        }, 2200);
      }

      button.addEventListener('click', function () {
        var title = share.getAttribute('data-share-title') || document.title;
        var url = window.location.href;
        var action;
        button.disabled = true;

        if (navigator.share) {
          action = navigator.share({ title: title, text: title, url: url });
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
          action = navigator.clipboard.writeText(url);
        } else {
          action = Promise.reject(new Error('share-unavailable'));
        }

        Promise.resolve(action)
          .then(function () { show(navigator.share ? defaultLabel : copiedLabel); })
          .catch(function () { show(errorLabel); })
          .finally(function () { button.disabled = false; });
      });
    });
  }

  function initPredictiveSearch() {
    var shells = Array.from(document.querySelectorAll('[data-predictive-search-shell]'));
    shells.forEach(function (shell) {
      var input = shell.querySelector('[data-predictive-search-input]');
      var results = shell.querySelector('[data-predictive-search-results]');
      if (!input || !results) return;
      var timeout = null;
      var request = null;

      function close() {
        results.hidden = true;
        input.setAttribute('aria-expanded', 'false');
      }
      function showMessage(message, extraClass) {
        results.className = 'predictive-search' + (extraClass ? ' ' + extraClass : '');
        results.innerHTML = '<p class="predictive-search-empty">' + escapeHtml(message) + '</p>';
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
      function render(products, query) {
        if (!products.length) {
          showMessage(shell.getAttribute('data-no-results') || 'No encontramos productos con esa búsqueda.');
          return;
        }
        var cards = products.map(function (product) {
          var image = product.featured_image && (product.featured_image.url || product.featured_image);
          var price = formatDominicanPrice(product.price || product.price_min || '');
          return '<a class="predictive-search-card" href="' + escapeHtml(product.url) + '">' +
            (image ? '<img src="' + escapeHtml(image) + '" alt="" loading="lazy" width="72" height="72">' : '<span class="predictive-search-card-placeholder" aria-hidden="true">O</span>') +
            '<span class="predictive-search-card-copy"><strong>' + escapeHtml(product.title) + '</strong><span>' + escapeHtml(price) + '</span></span>' +
            '</a>';
        }).join('');
        var allLabel = shell.getAttribute('data-view-all') || 'Ver todos los resultados';
        results.className = 'predictive-search';
        var heading = (shell.getAttribute('data-results-label') || 'Results for “%QUERY%”').replace('%QUERY%', escapeHtml(query));
        results.innerHTML = '<div class="predictive-search-heading"><span>' + heading + '</span></div><div class="predictive-search-grid">' + cards + '</div><button class="predictive-search-view-all" type="submit">' + escapeHtml(allLabel) + ' →</button>';
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
      function search() {
        var query = input.value.trim();
        if (request) request.abort();
        if (!query) { close(); return; }
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var url = root + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        request = new AbortController();
        fetch(url, { headers: { Accept: 'application/json' }, signal: request.signal })
          .then(function (response) { if (!response.ok) throw new Error('predictive-search'); return response.json(); })
          .then(function (data) {
            var products = data && data.resources && data.resources.results && data.resources.results.products || [];
            render(products, query);
          })
          .catch(function (error) {
            if (error.name !== 'AbortError') close();
          });
      }
      input.addEventListener('input', function () {
        window.clearTimeout(timeout);
        timeout = window.setTimeout(search, 170);
      });
      input.addEventListener('focus', function () { if (input.value.trim() && results.innerHTML) results.hidden = false; });
      input.addEventListener('keydown', function (event) { if (event.key === 'Escape') close(); });
      shell.addEventListener('click', function (event) {
        if (event.target.closest('.predictive-search-view-all')) {
          event.preventDefault();
          input.form.submit();
        }
      });
      document.addEventListener('click', function (event) {
        if (!shell.contains(event.target)) close();
      });
    });
  }

  function initQuickAdd() {
    var forms = Array.from(document.querySelectorAll('[data-quick-add]'));
    forms.forEach(function (form) {
      if (form.dataset.quickAddBound === 'true') return;
      form.dataset.quickAddBound = 'true';
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = form.querySelector('button');
        if (!button || button.disabled) return;
        var original = button.textContent;
        var status = button.querySelector('.quick-add-status');
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        button.disabled = true;
        button.classList.remove('is-added', 'is-error');
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        if (status) status.textContent = button.getAttribute('data-loading-label') || 'Añadiendo';
        fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (response) { if (!response.ok) throw new Error('cart-add'); return response.json(); })
          .then(function () {
            button.classList.remove('is-loading');
            button.classList.add('is-added');
            if (status) status.textContent = button.getAttribute('data-success-label') || 'Añadido';
            return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
          })
          .then(function (response) { return response ? response.json() : null; })
          .then(function (cart) {
            if (!cart) return;
            var badges = Array.from(document.querySelectorAll('[data-cart-badge]'));
            badges.forEach(function (badge) { badge.textContent = cart.item_count; });
            if (!badges.length && cart.item_count > 0) window.location.reload();
          })
          .catch(function () {
            button.classList.remove('is-loading');
            button.classList.add('is-error');
            if (status) status.textContent = button.getAttribute('data-error-label') || 'Reintentar';
          })
          .finally(function () {
            window.setTimeout(function () {
              button.disabled = false;
              button.classList.remove('is-loading', 'is-added', 'is-error');
              button.removeAttribute('aria-busy');
              if (status) status.textContent = '';
              if (!status) button.textContent = original;
            }, 1600);
          });
      });
    });
  }

  function initHeroCarousel() {
    var carousels = Array.from(document.querySelectorAll('[data-hero-carousel]'));
    carousels.forEach(function (carousel) {
      var stage = carousel.querySelector('[data-hero-stage]');
      var cards = Array.from(carousel.querySelectorAll('[data-hero-card]'));
      var previous = carousel.querySelector('[data-hero-prev]');
      var next = carousel.querySelector('[data-hero-next]');
      var status = carousel.querySelector('[data-hero-status]');
      if (!stage) return;
      if (cards.length < 4 || !previous || !next) {
        window.requestAnimationFrame(function () { stage.classList.add('hero-ready'); });
        return;
      }

      var page = 0;
      var pageCount = Math.ceil(cards.length / 3);
      var timer = null;
      var interval = Math.max(5000, Number(carousel.getAttribute('data-hero-interval')) || 8000);
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function render(nextPage) {
        page = (nextPage + pageCount) % pageCount;
        var start = page * 3;
        stage.setAttribute('data-hero-page', String(page % 3));
        cards.forEach(function (card, index) {
          var active = index >= start && index < start + 3;
          card.classList.toggle('is-active', active);
          card.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (active) card.removeAttribute('tabindex');
          else card.setAttribute('tabindex', '-1');
        });
        if (status) status.textContent = (page + 1) + ' / ' + pageCount;
      }
      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }
      function start() {
        if (reducedMotion || carousel.getAttribute('data-hero-autoplay') !== 'true' || timer) return;
        timer = window.setInterval(function () { render(page + 1); }, interval);
      }
      function move(step, event) {
        if (event) { event.preventDefault(); event.stopPropagation(); }
        render(page + step);
        stop();
        start();
      }

      previous.addEventListener('click', function (event) { move(-1, event); });
      next.addEventListener('click', function (event) { move(1, event); });
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', function (event) { if (!carousel.contains(event.relatedTarget)) start(); });

      var touchStartX = null;
      stage.addEventListener('touchstart', function (event) { touchStartX = event.changedTouches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (event) {
        if (touchStartX === null) return;
        var distance = event.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(distance) > 42) move(distance > 0 ? -1 : 1, event);
      }, { passive: true });

      render(0);
      window.requestAnimationFrame(function () { stage.classList.add('hero-ready'); });
      start();
    });
  }

  function initHeroCardImageCarousels() {
    Array.from(document.querySelectorAll('[data-hero-card-media]')).forEach(function (media) {
      var card = media.closest('[data-hero-card]');
      var images = Array.from(media.querySelectorAll('[data-hero-card-image]'));
      if (!card || images.length < 2) return;
      var index = 0;
      var timer = null;
      var pending = false;
      function show(nextIndex) {
        var targetIndex = (nextIndex + images.length) % images.length;
        var target = images[targetIndex];
        if (!target) return;
        if (!target.complete || target.naturalWidth === 0) {
          if (pending) return;
          pending = true;
          target.loading = 'eager';
          target.addEventListener('load', function () { pending = false; show(targetIndex); }, { once: true });
          return;
        }
        var current = images[index];
        index = targetIndex;
        target.classList.add('is-active');
        window.requestAnimationFrame(function () {
          if (current && current !== target) current.classList.remove('is-active');
        });
      }
      function start() {
        if (timer) return;
        show(index + 1);
        timer = window.setInterval(function () { show(index + 1); }, 1450);
      }
      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
        show(0);
      }
      card.addEventListener('mouseenter', start);
      card.addEventListener('mouseleave', stop);
      card.addEventListener('focusin', start);
      card.addEventListener('focusout', function (event) { if (!card.contains(event.relatedTarget)) stop(); });
    });
  }

  function initRevealAnimations() {
    var elements = Array.from(document.querySelectorAll('main > section:not([data-reveal-disabled]), .home-section:not([data-reveal-disabled])'));
    if (!elements.length) return;
    elements.forEach(function (element) { element.classList.add('reveal-section'); });
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion || !('IntersectionObserver' in window)) {
      elements.forEach(function (element) { element.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries, currentObserver) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        currentObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -9% 0px', threshold: .08 });
    elements.forEach(function (element, index) {
      element.style.transitionDelay = Math.min(index * 55, 220) + 'ms';
      observer.observe(element);
    });
  }

  function initTrackForms() {
    Array.from(document.querySelectorAll('[data-track-form]')).forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var number = form.querySelector('[name="tracking_number"]');
        var status = form.querySelector('[data-track-status]');
        var url = form.getAttribute('data-effi-url');
        if (!number || !number.value.trim() || !url) return;
        if (status) status.textContent = 'Abriendo el rastreo oficial de EFFI…';
        window.open(url, '_blank', 'noopener');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var thumbs = Array.from(document.querySelectorAll('.thumb-item'));
    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () { setProductImage(index); });
    });

    var prev = document.querySelector('.nav-arrow.prev');
    var next = document.querySelector('.nav-arrow.next');
    if (prev) prev.addEventListener('click', function () {
      if (thumbs.length) setProductImage((Math.max(0, thumbs.findIndex(function (t) { return t.classList.contains('active'); })) - 1 + thumbs.length) % thumbs.length);
    });
    if (next) next.addEventListener('click', function () {
      if (thumbs.length) setProductImage((Math.max(0, thumbs.findIndex(function (t) { return t.classList.contains('active'); })) + 1) % thumbs.length);
    });

    var select = document.getElementById('VariantSelect');
    if (select) {
      select.addEventListener('change', function () { updateVariantState(select.options[select.selectedIndex]); });
    }

    var input = document.getElementById('QuantityInput');
    var minus = document.getElementById('QtyMinus');
    var plus = document.getElementById('QtyPlus');
    if (input && minus) minus.addEventListener('click', function () { input.value = Math.max(1, Number(input.value || 1) - 1); });
    if (input && plus) plus.addEventListener('click', function () { input.value = Math.min(8, Number(input.value || 1) + 1); });

    initProductCardCarousels();
    initRelatedCarousels();
    initCatalogPagination();
    initPageTransitions();
    initHeroCarousel();
    initHeroCardImageCarousels();
    initTrackForms();
    initRevealAnimations();
    initProductShare();
    initPredictiveSearch();
    initQuickAdd();
  });
})();

/* External product rating source disclosure. */
(function () {
  'use strict';

  function initExternalRatings() {
    document.querySelectorAll('[data-external-rating]').forEach(function (root) {
      if (root.dataset.externalRatingReady === 'true') return;
      root.dataset.externalRatingReady = 'true';

      var trigger = root.querySelector('[data-external-rating-trigger]');
      var notice = root.querySelector('[data-external-rating-notice]');
      var close = root.querySelector('[data-external-rating-close]');
      if (!trigger || !notice) return;

      function setOpen(open) {
        notice.hidden = !open;
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      trigger.addEventListener('click', function () {
        setOpen(notice.hidden);
      });

      if (close) {
        close.addEventListener('click', function (event) {
          event.stopPropagation();
          setOpen(false);
        });
      }

      document.addEventListener('click', function (event) {
        if (!notice.hidden && !root.contains(event.target)) setOpen(false);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !notice.hidden) {
          setOpen(false);
          trigger.focus();
        }
      });

      /* Show the disclosure once per product/browser, then keep only the info affordance. */
      var productId = root.getAttribute('data-product-id') || 'unknown';
      var storageKey = 'ozelotExternalRatingNotice:' + productId;
      try {
        if (!window.localStorage.getItem(storageKey)) {
          window.setTimeout(function () {
            setOpen(true);
            window.localStorage.setItem(storageKey, 'shown');
            window.setTimeout(function () { setOpen(false); }, 6500);
          }, 650);
        }
      } catch (error) {
        /* Storage can be unavailable in private/restricted browsing. Click disclosure still works. */
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initExternalRatings);
  } else {
    initExternalRatings();
  }

  document.addEventListener('shopify:section:load', initExternalRatings);
})();
